import {
  JOB_CATEGORIES,
  type JobCategory,
} from 'src/app/shared/constants/jobCategories';

import { log } from '../logging';

export const findAdcentreCategoryIdsBySeekId = (
  data: JobCategory[],
  seekSubClassificationId: number,
) => {
  let categoryId;
  let subCategoryId;

  data.find((c) => {
    c.subClassifications?.find((sc) => {
      if (sc.seekId === seekSubClassificationId) {
        categoryId = sc.classificationId;
        subCategoryId = sc.id;
      }
    });
  });

  return { categoryId, subCategoryId };
};

export const getClassificationDataBySeekIds = (
  categoryClassId: number,
  categorySubClassId: number,
): Classification => {
  const classification = JOB_CATEGORIES.find(
    (c) => c.seekId === categoryClassId,
  );
  const subClassification = classification?.subClassifications?.find(
    (sc) => sc.seekId === categorySubClassId,
  );

  if (!classification) {
    log.error(
      'getClassificationDataBySeekIds: unable to find AdCentre classificationId from seekId',
      { categoryClassId },
    );
  }

  if (!subClassification) {
    log.error(
      'getClassificationDataBySeekIds: unable to find AdCentre subClassificationId from seekId',
      { categorySubClassId },
    );
  }

  return {
    classificationId: classification?.id?.toString(),
    classificationText: classification?.text,
    seekClassificationId: classification?.seekId.toString(),
    subClassificationId: subClassification?.id.toString(),
    subClassificationText: subClassification?.text,
    seekSubClassificationId: subClassification?.seekId.toString(),
  };
};

export const getClassificationDataByAdCenterIds = (
  classificationId?: number,
  subClassificationId?: number,
) => {
  if (!classificationId) {
    return;
  }

  const classification = JOB_CATEGORIES.find((c) => c.id === classificationId);
  const subClassification = classification?.subClassifications?.find(
    (sc) => sc.id === subClassificationId,
  );

  if (classificationId && !classification) {
    log.error(
      'getClassificationDataByAdCenterIds: unable to find classification locally from classificationId',
      { classificationId },
    );
  }

  if (subClassificationId && !subClassification) {
    log.error(
      'getClassificationDataByAdCenterIds: unable to find subClassification locally from subClassificationId',
      { subClassificationId },
    );
  }

  return {
    classificationId: classificationId.toString(),
    classificationText: classification?.text,
    seekClassificationId: classification?.seekId.toString(),
    subClassificationId: subClassification?.id.toString(),
    subClassificationText: subClassification?.text,
    seekSubClassificationId: subClassification?.seekId.toString(),
  };
};

export interface Classification {
  classificationId?: string;
  classificationText?: string;
  seekClassificationId?: string;
  subClassificationId?: string;
  subClassificationText?: string;
  seekSubClassificationId?: string;
}
